// extracted by mini-css-extract-plugin
module.exports = {"container":"demo_container__1KBX8","item":"demo_item__4HoSS"};